<p>book-detail works!</p>
